// import { Badge, Col, Container, Row } from 'react-bootstrap';
// import FeatherIcon from 'feather-icons-react';

// const About = () => {
//     return (
//         <>
//             <section className="py-5 border-light-subtle">
//                 <Container>
//                     <Row className="justify-content-center text-center mb-5">
//                         <Col lg={8}>

//                             <h2 className="fw-bold display-9">Empowering Smarter Sales, Smarter Growth</h2>
//                             <p className="text-muted lead mt-3">
//                                 SalesTrackify is an all-in-one CRM platform built to streamline your sales, marketing, support,
//                                 and finance operations — helping businesses grow smarter and faster.
//                             </p>
//                         </Col>
//                     </Row>

//                     <Row className="g-4 align-items-stretch">
//                         <Col md={6}>
//                             <div className="p-4 bg-white rounded shadow-sm h-100">
//                                 <h5 className="fw-semibold mb-3 text-primary">🚩 The Problem</h5>
//                                 <p className="text-muted mb-4">
//                                     Managing leads, deals, invoices, and customer support across multiple tools is chaotic and inefficient.
//                                 </p>

//                                 <h5 className="fw-semibold mb-3 text-success">✅ Our Solution</h5>
//                                 <p className="text-muted mb-4">
//                                     With SalesTrackify, you can manage everything in one centralized, intuitive platform —
//                                     simplifying your business processes and boosting productivity.
//                                 </p>

//                                 <h5 className="fw-semibold mb-3 text-info">👥 Who is it for?</h5>
//                                 <p className="text-muted">
//                                     Whether you're a startup, growing business, or enterprise — SalesTrackify is built for:
//                                 </p>
//                                 <ul className="text-muted ps-3">
//                                     <li>Sales teams</li>
//                                     <li>Marketing professionals</li>
//                                     <li>Customer support agents</li>
//                                     <li>Finance & operations teams</li>
//                                 </ul>
//                             </div>
//                         </Col>

//                         <Col md={6}>
//                             <div className="p-4 bg-white rounded shadow-sm h-100">
//                                 <h5 className="fw-semibold mb-4 text-warning">⭐ What Makes Us Different?</h5>
//                                 <ul className="list-unstyled text-muted fs-6">
//                                     <li className="mb-3 d-flex">
//                                         <FeatherIcon icon="check-circle" size={18} className="text-success me-2 mt-1" />
//                                         Unified dashboards for sales, marketing, finance & support
//                                     </li>
//                                     <li className="mb-3 d-flex">
//                                         <FeatherIcon icon="check-circle" size={18} className="text-success me-2 mt-1" />
//                                         Built-in reporting & analytics for better decision-making
//                                     </li>
//                                     <li className="mb-3 d-flex">
//                                         <FeatherIcon icon="check-circle" size={18} className="text-success me-2 mt-1" />
//                                         Easy-to-use, modular and scalable to fit your business
//                                     </li>
//                                     <li className="mb-3 d-flex">
//                                         <FeatherIcon icon="check-circle" size={18} className="text-success me-2 mt-1" />
//                                         Quick onboarding and custom configuration options
//                                     </li>
//                                 </ul>
//                             </div>
//                         </Col>
//                     </Row>
//                 </Container>
//             </section>



//         </>
//     );
// };

// export default About;



import { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import FeatherIcon from "feather-icons-react";
import "./about.css";


const About = () => {

    // Scroll Animation
    useEffect(() => {
        const elements = document.querySelectorAll(".animate");

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("show");
                    }
                });
            },
            { threshold: 0.2 }
        );

        elements.forEach((el) => observer.observe(el));
    }, []);

    return (
        <>
            <section
                style={{
                    background: "linear-gradient(135deg, #e3f2fd 0%, #e8f0ff 100%)",
                    padding: "80px 0",
                    textAlign: "center",
                    borderBottomLeftRadius: "30px",
                    borderBottomRightRadius: "30px",
                    marginLeft: 25,
                    marginRight: 25
                }}     >
                {/* <h1 style={{ fontSize: "48px", fontWeight: "700", color: "#1b1f29", }}  >
                    About Us
                </h1> */}

                <h1
                    style={{
                        fontSize: "48px",
                        fontWeight: 700,
                        background: "linear-gradient(90deg, #3b82f6, #60a5fa, #93c5fd)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                    }}
                >
                    About Us
                </h1>
                <p style={{ marginTop: "10px", fontSize: "18px", color: "#6c757d", }}   >
                    SalesTrackify is a smart, scalable CRM platform built by
                    <strong> CoreScripts Technologies Ltd</strong>, a UK-based IT company.
                </p>
            </section>



            {/* ====================== */}

            <section className="about-section about-row-section">
                <div className="container">

                    {/* HEADER */}
                    <div className="section-header animate animate-delay-1">
                        <h2>Who We Are</h2>
                        <p className="header-subtext">
                            Empowering businesses with intelligent sales solutions
                        </p>
                    </div>

                    <div className="row align-items-center mt-5">
                        {/* LEFT IMAGE */}
                        <div className="col-lg-6 ">
                            <img
                                src={require('../../../assets/images/About/Team-pana.png')}
                                alt="Team"
                                style={{ width: 500, height: 550 }}
                                className="about-row-image"
                            />
                        </div>

                        {/* RIGHT TEXT */}
                        <div className="col-lg-6">
                            <h3 className="row-title">SalesTrackify</h3>

                            <p className="row-para">
                                Designed for small and medium-sized businesses that want a simple,
                                powerful way to manage sales, track leads, and build stronger customer
                                relationships.
                            </p>

                            <p className="row-para">
                                Whether you sell services, products, or a mix of both, SalesTrackify
                                provides an end-to-end CRM platform that keeps your team organized and
                                your pipeline visible.
                            </p>

                            {/* COMPANY INFO – POLISHED */}
                            <div className="company-info animate animate-delay-2">
                                <div className="company-logo">
                                    <div className="icon">
                                        <FeatherIcon icon="code" size="22" color="#ffffff" />
                                    </div>
                                    <h4 className="company-name">CoreScripts Technologies Ltd</h4>
                                </div>

                                <p className="company-description">
                                    The product is owned and developed by CoreScripts Technologies Ltd,
                                    a UK-based IT company specializing in bespoke software development,
                                    product engineering, and scalable business solutions.
                                </p>

                                <div className="location-badge">
                                    <FeatherIcon icon="map-pin" size="16" className="me-2" />
                                    United Kingdom
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* <Container> */}
            {/* Vision – Mission – Strategy Section */}
            <div className="section-box bg-light  vms-container" style={{
                background: "linear-gradient(135deg, #e3f2fd 0%, #e8f0ff 100%)",
                // background: "linear-gradient(135deg, #e3f2fd 0%, #e8f0ff 100%)",
                // padding: "80px 0",
                textAlign: "center",
                borderBottomLeftRadius: "30px",
                borderBottomRightRadius: "30px",
                // marginLeft: 15,
                // marginRight: 15
            }}>
                <Row className="justify-content-center">
                    {/* Vision */}
                    <Col md={4} className="mb-4">
                        <div className="vms-card">
                            <div className="vms-icon-circle" style={{ borderColor: "#00b4ff" }}>
                                <FeatherIcon icon="target" size={40} color="#00b4ff" />
                            </div>
                            <h3 className="vms-title">OUR VISION</h3>
                            <p className="vms-text">
                                To be the CRM of choice for small and medium businesses worldwide by
                                offering a platform that adapts to unique processes and scales as
                                businesses grow.
                            </p>
                            <div className="vms-bottom-strip vms-yellow"></div>
                        </div>
                    </Col>

                    {/* Mission */}
                    <Col md={4} className="mb-4">
                        <div className="vms-card">
                            <div className="vms-icon-circle" style={{ borderColor: "#00b4ff" }}>
                                <FeatherIcon icon="eye" size={40} color="#00b4ff" />
                            </div>
                            <h3 className="vms-title">OUR MISSION</h3>
                            <p className="vms-text">
                                To deliver a secure, high-performance CRM platform that helps companies
                                manage their sales pipeline, improve customer retention and gain
                                real-time visibility.
                            </p>
                            <div className="vms-bottom-strip vms-red"></div>
                        </div>
                    </Col>

                    {/* Strategy */}
                    <Col md={4} className="mb-4">
                        <div className="vms-card">
                            <div className="vms-icon-circle" >
                                <FeatherIcon icon="chrome" size={40} color="#00b4ff" />
                            </div>
                            <h3 className="vms-title">OUR PURPOSE</h3>
                            <p className="vms-text">
                                Our purpose is to give growing businesses a CRM that is fast, intuitive and
                                easy to adopt. We remove unnecessary complexity so your teams can spend more
                                time building relationships and closing deals.
                            </p>
                            <div className="vms-bottom-strip vms-green"></div>
                        </div>
                    </Col>

                </Row>
            </div>

            {/* </Container> */}



            {/* ====================== */}
            <section className="why-choose-clean">
                {/* <Container> */}
                <Row className="justify-content-center">
                    <Col lg={10}>
                        <div className="why-card">

                            <h2 className="title text-center">Why Businesses Choose SalesTrackify</h2>
                            <p className="desc ">
                                Built for growing businesses that need a powerful yet easy-to-use CRM.
                                SalesTrackify simplifies sales processes, improves team productivity,
                                and ensures secure, reliable performance.
                            </p>
                            <span className="line"></span>

                            <Row className="mt-5">

                                <Col md={4} className="text-center mb-4">
                                    <div className="why-item">
                                        <div className="icon-circle">
                                            <FeatherIcon icon="briefcase" size={28} />
                                        </div>
                                        <h5>Built for SMEs</h5>
                                        <p>
                                            Designed for small and medium-sized businesses — services,
                                            retail, e-commerce, B2B and more.
                                        </p>
                                    </div>
                                </Col>

                                <Col md={4} className="text-center mb-4">
                                    <div className="why-item">
                                        <div className="icon-circle">
                                            <FeatherIcon icon="smile" size={28} />
                                        </div>
                                        <h5>Easy to Use</h5>
                                        <p>
                                            Clean interface with intuitive workflows that help your team
                                            get value from day one.
                                        </p>
                                    </div>
                                </Col>

                                <Col md={4} className="text-center mb-4">
                                    <div className="why-item">
                                        <div className="icon-circle">
                                            <FeatherIcon icon="layers" size={28} />
                                        </div>
                                        <h5>Scalable CRM Features</h5>
                                        <p>
                                            Lead capture, pipeline management, automation, reporting —
                                            everything grows with your business.
                                        </p>
                                    </div>
                                </Col>

                                <Col md={4} className="text-center mb-4">
                                    <div className="why-item">
                                        <div className="icon-circle">
                                            <FeatherIcon icon="shield" size={28} />
                                        </div>
                                        <h5>Secure & Reliable</h5>
                                        <p>
                                            Built with modern security practices and aligned with GDPR
                                            and UK/EU standards.
                                        </p>
                                    </div>
                                </Col>

                                <Col md={4} className="text-center mb-4">
                                    <div className="why-item">
                                        <div className="icon-circle">
                                            <FeatherIcon icon="users" size={28} />
                                        </div>
                                        <h5>Backed by Experts</h5>
                                        <p>
                                            Supported by CoreScripts Technologies Ltd with continuous
                                            updates and improvements.
                                        </p>
                                    </div>
                                </Col>

                            </Row>
                        </div>
                    </Col>
                </Row>
                {/* </Container> */}
            </section>

            {/* Who We Are */}
            <Container>
                <section className="about-section py-5">
                    <div className="container">
                        <div className="text-center mb-5">
                            <h2 className="fw-bold">
                                About <span className="text-primary">CoreScripts Technologies Ltd</span>
                            </h2>
                            <p className="text-muted col-lg-7 mx-auto">
                                CoreScripts Technologies Ltd is an IT company based in the UK, providing
                                bespoke software solutions and full-cycle product engineering services.
                            </p>
                        </div>

                        <div className="p-4 shadow rounded-4 bg-white">
                            <p className="mb-4 fs-5">
                                We work with organisations that want to modernise their systems, automate processes
                                and launch scalable SaaS products.
                            </p>

                            <h5 className="fw-bold mb-3">Our Expertise Includes:</h5>

                            <ul className="list-unstyled fs-6">
                                <li className="mb-2 d-flex"><span className="me-2">•</span>Bespoke web and cloud applications</li>
                                <li className="mb-2 d-flex"><span className="me-2">•</span>Product engineering and SaaS development</li>
                                <li className="mb-2 d-flex"><span className="me-2">•</span>Systems integration and API development</li>
                                <li className="mb-2 d-flex"><span className="me-2">•</span>Operational tooling and internal platforms</li>
                            </ul>

                            <div className="mt-4 p-3 bg-light rounded-3">
                                <strong>SalesTrackify</strong> is one of our flagship products, reflecting our passion for building
                                robust, user-focused software that helps businesses grow.
                            </div>
                        </div>
                    </div>
                </section>
            </Container>






            <section className="py-5" style={{ background: "linear-gradient(135deg, #e3f2fd 0%, #e8f0ff 100%)", }}>
                <div className="container text-center">

                    <h2 className="fw-bold mb-3">
                        What’s Next for <span className="text-primary">SalesTrackify</span>
                    </h2>

                    <p className="text-muted col-lg-7 mx-auto mb-4">
                        We are continuously improving SalesTrackify with new CRM features, integrations,
                        and automation — all powered by real customer feedback.
                    </p>

                    <div className="d-flex justify-content-center gap-3 flex-wrap mt-4">
                        {/* <a href="#demo" className="btn btn-primary btn-lg px-4">Book a Demo</a> */}
                        <a href="/contact" className="btn btn-primary btn-lg px-4">Contact Us</a>
                    </div>

                </div>
            </section>
        </>
    );
};

export default About;

